import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { IconPredefined } from "../../../../shared/icons/Icon";
import { PredefinedIconType } from "../../../../shared/icons/Icon/Predefined";
import NewHeadline from "../../../../shared/NewHeadline";
import SmallShapeContainer from "../../../../shared/SmallShapeContainer";

const Container = styled.div`
    margin-top: 50px;
    margin-bottom: 50px;
    ${({ theme }) => theme.paddings.containerOuterInner.left};
    ${({ theme }) => theme.paddings.containerOuterInner.right};

    color: ${({ theme }) => theme.colors.blue.toString()};
`;

const Headline = styled(NewHeadline)`
    margin-top: 20px;
`;

const FlexBox = styled.div`
    display: flex;
    flex-direction: column;
    ${({ theme }) =>
        theme.breakpoints.from.medium.css`
            flex-direction: row;
            column-gap: 50px;
    `}
`;

const TextBox = styled.p`
    ${({ theme }) =>
        theme.breakpoints.from.medium.css`
            max-width: 50%;
    `}
`;

const ContactBox = styled.div`
    margin-bottom: 30px;
    ${({ theme }) =>
        theme.breakpoints.from.medium.css`
            max-width: 30%;
    `}
`;

const StyledLink = styled.a`
    text-decoration: underline;

    :hover {
        color: ${({ theme }) => theme.colors.red.toString()};
    }
`;

const Flex = styled.div`
    margin: 30px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 30px;
    ${({ theme }) =>
        theme.breakpoints.from.medium.css`
            row-gap: 0;
            justify-content: space-between;
            
    `}
    ${({ theme }) =>
        theme.breakpoints.from.large.css`
          ${theme.paddings.containerInner.left};
          ${theme.paddings.containerInner.right};
    `}
    ${({ theme }) =>
        theme.breakpoints.from.extraLarge.css`
          padding: 0;
    `}
`;

const Card = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    max-width: 400px;
    margin: 0 atuo;
`;

const Price = styled.p`
    font-size: large;
`;

const BackgroundContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 20px 0;
    background-color: ${({ theme }) => theme.colors.blue.toString()};
`;

const RowItem = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 500px;
`;

const Text = styled.div`
    max-width: 60%;
`;

const CarCare = ({ gasStation }) => {
    const showBox = gasStation && gasStation.s_id === 1020;

    return (
        showBox && (
            <Container>
                <Headline>Premium Fahrzeugaufbereitung</Headline>
                <FlexBox>
                    <TextBox>
                        Gönne Deinem Auto eine unserer erstklassigen
                        Autowäschen. Von der klassischen Autowäsche über
                        Polieren und Versiegeln bis zur Nassreinigung und
                        Lederpflege ist bei uns vieles möglich. Schau Dir unser
                        Angebot an.
                    </TextBox>
                    <ContactBox>
                        <p>
                            <b>Öffnungszeiten</b> <br />
                            Montag - Samstag <br />
                            09.00 - 18.00 <br />
                            oder nach Absprache
                        </p>
                        <br />
                        <p>
                            Bitte vereinbaren Sie einen Termin unter: <br />
                            Tel.: +49 151 29222494
                            <br />
                            E-Mail:{" "}
                            <StyledLink href="mailto:carcare-posthausen@hoyer.de">
                                carcare-posthausen@hoyer.de
                            </StyledLink>
                        </p>
                    </ContactBox>
                </FlexBox>
                <Headline>Unsere Angebote</Headline>
                <Flex>
                    <Card>
                        <SmallShapeContainer
                            css={css`
                                margin: 0 auto;
                            `}
                        >
                            <SmallShapeContainer.ImageContainer>
                                <BackgroundContainer>
                                    <IconPredefined
                                        type={PredefinedIconType.carCare1}
                                        size="100px"
                                    />
                                </BackgroundContainer>
                            </SmallShapeContainer.ImageContainer>

                            <SmallShapeContainer.TextContainer>
                                <b>Standard-Programm</b>
                                <p>
                                    Standard-Wäsche, Felgenreinigung,
                                    Scheibenreinigung außen, Kunststoff- und
                                    Lackversiegelung
                                </p>
                                <Price>ab 29,50 €</Price>
                            </SmallShapeContainer.TextContainer>
                        </SmallShapeContainer>
                    </Card>
                    <Card>
                        <SmallShapeContainer
                            css={css`
                                margin: 0 auto;
                            `}
                        >
                            <SmallShapeContainer.ImageContainer>
                                <BackgroundContainer>
                                    <IconPredefined
                                        type={PredefinedIconType.carCare2}
                                        size="100px"
                                    />
                                </BackgroundContainer>
                            </SmallShapeContainer.ImageContainer>

                            <SmallShapeContainer.TextContainer>
                                <b>Komfort- Programm</b>
                                <p>
                                    Standard-Programm <br />
                                    + Scheibenreinigung innen <br />
                                    + intensive Innenraumreinigung <br />+
                                    gründliches Aussaugen
                                </p>
                                <Price>ab 59,50 €</Price>
                            </SmallShapeContainer.TextContainer>
                        </SmallShapeContainer>
                    </Card>
                </Flex>
                <Flex>
                    <Card>
                        <SmallShapeContainer
                            css={css`
                                margin: 0 auto;
                            `}
                        >
                            <SmallShapeContainer.ImageContainer>
                                <BackgroundContainer>
                                    <IconPredefined
                                        type={PredefinedIconType.carCare3}
                                        size="100px"
                                    />
                                </BackgroundContainer>
                            </SmallShapeContainer.ImageContainer>

                            <SmallShapeContainer.TextContainer>
                                <b>Premium- Programm</b>
                                <p>
                                    Komfort-Programm <br />
                                    + Polsterreinigung <br />
                                    + maschinelle Hochglanzpolitur <br />+ inkl.
                                    Versiegelung
                                </p>
                                <Price>ab 199,50 €</Price>
                            </SmallShapeContainer.TextContainer>
                        </SmallShapeContainer>
                    </Card>
                    <Card>
                        <SmallShapeContainer
                            css={css`
                                margin: 0 auto;
                            `}
                        >
                            <SmallShapeContainer.ImageContainer>
                                <BackgroundContainer>
                                    <IconPredefined
                                        type={PredefinedIconType.carCare4}
                                        size="100px"
                                    />
                                </BackgroundContainer>
                            </SmallShapeContainer.ImageContainer>

                            <SmallShapeContainer.TextContainer>
                                <b>Keramik- Versiegelung</b>
                                <p>
                                    24 Stunden Trocknung und je nach
                                    Lackbeschaffenheit Mehrkosten
                                </p>
                                <Price>ab 499,00 €</Price>
                            </SmallShapeContainer.TextContainer>
                        </SmallShapeContainer>
                    </Card>
                </Flex>
                <Flex>
                    <p>
                        Für besonders stark verschmutzte Fahrzeuge wird ein
                        Zuschlag nach Aufwand berechnet.
                        <br />
                        Transporter, Geländewagen, Familien-Van <b>+ 10 €</b>
                    </p>
                </Flex>
                <Headline>Extras</Headline>
                <RowItem>
                    <Text>Pkw-Entschriftung</Text>
                    <Price>
                        <b>ab 24,50 €</b>
                    </Price>
                </RowItem>
                <RowItem>
                    <Text>Flugrost- & Teerentfernung</Text>
                    <Price>
                        <b>ab 20,50 €</b>
                    </Price>
                </RowItem>
                <RowItem>
                    <Text>Scheinwerferaufbereitung</Text>
                    <Price>
                        <b>ab 70,00 €</b>
                    </Price>
                </RowItem>
                <RowItem>
                    <Text>Nassreinigung Dachhimmel</Text>
                    <Price>
                        <b>ab 49,50 €</b>
                    </Price>
                </RowItem>
                <RowItem>
                    <Text>Lackaufwertung</Text>
                    <Price>
                        <b>ab 49,50 €</b>
                    </Price>
                </RowItem>
                <RowItem>
                    <Text>Lederpflege</Text>
                    <Price>
                        <b>ab 69,50 €</b>
                    </Price>
                </RowItem>
                <RowItem>
                    <Text>Nassreinigung Polster und Fußmatten</Text>
                    <Price>
                        <b>ab 89,50 €</b>
                    </Price>
                </RowItem>
                <RowItem>
                    <Text>Politur und Versiegelung</Text>
                    <Price>
                        <b>ab 99,50 €</b>
                    </Price>
                </RowItem>
                <RowItem>
                    <Text>Reinigung & Imprägnierung Cabrio-Verdeck</Text>
                    <Price>
                        <b>ab 119,50 €</b>
                    </Price>
                </RowItem>
            </Container>
        )
    );
};

export default CarCare;
